<template v-if="driver">
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <base-material-card
          icon="mdi-account"
          :title="
            id
              ? $i18n.t('Edit Employee') + ' - ' + driver.name
              : $i18n.t('Create Employee') +
                (driver.name ? ' - ' + driver.name : '')
          "
          class="px-3 py-1 small-icon"
        >
          <v-form id="form" v-model="isValid">
            <v-col>
              <v-row>
                <v-col cols="12" md="9" lg="9">
                  <v-row>
                    <v-col cols="12" md="12" lg="12">
                      <v-card>
                        <v-row style="padding: 10px 10px">
                          <v-col cols="12" xs="6" sm="4" md="3" lg="3">
                            <v-img
                              v-if="driver.pic"
                              :src="driver.pic"
                              style="
                                border-radius: 100px;
                                width: 60px;
                                height: 60px;
                              "
                            ></v-img>
                            <!-- <v-img
                              v-else
                              src="@/assets/driver.png"
                              alt="image not available"
                              style="border-radius:100px;width:70px;"
                            ></v-img>-->
                          </v-col>
                          <v-col cols="12" xs="6" sm="4" md="5" lg="5">
                            <h2>{{ driver.name }}</h2>
                            <h3>{{ driver.phone }}</h3>
                          </v-col>
                          <v-col
                            cols="12"
                            xs="6"
                            sm="4"
                            md="4"
                            lg="4"
                            class="text-right"
                          >
                            <v-chip
                              v-if="driver.compliant == 1"
                              small
                              color="green"
                              text-color="white"
                              >Compliance Done</v-chip
                            >
                            <v-chip
                              v-if="driver.compliant == 2"
                              small
                              color="red"
                              text-color="white"
                              >Not Compliant</v-chip
                            >
                            <v-chip small v-if="driver.compliant == 3"
                              >Compliance Due</v-chip
                            >
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-tabs-items v-model="activeTab">
                        <v-tab-item key="home" style="width: 100%">
                          <v-card flat>
                            <profile @reload="get()" :value="driver"></profile>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="addresss" style="width: 100%">
                          <v-card flat>
                            <addresss
                              @reload="get()"
                              :value="driver"
                            ></addresss>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="photos">
                          <v-card flat>
                            <pictures
                              @reload="get()"
                              :value="driver"
                            ></pictures>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="settings">
                          <v-card flat>
                            <other @reload="get()" :value="driver"></other>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="policeVerify">
                          <v-card flat>
                            <police-verify
                              @reload="get()"
                              :value="driver"
                            ></police-verify>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="expenses">
                          <v-card flat>
                            <cash-salary
                              @reload="get()"
                              :value="driver"
                            ></cash-salary>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="insurance">
                          <v-card flat>
                            <insurance
                              @reload="get()"
                              :value="driver"
                            ></insurance>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="permits">
                          <v-card flat>
                            <permits @reload="get()" :value="driver"></permits>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="config">
                          <v-card flat>
                            <config @reload="get()" :value="driver"></config>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-col>
                  </v-row>

                  <v-row style="padding: 0 20px">
                    <v-btn small fab :to="'/drivers'" v-if="!singlePage">
                      <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <z-confirm-button
                      v-if="driver.showMrkCmpDone"
                      color="green lighten-1"
                      :loading="loading"
                      :message="
                        $i18n.t('Do you want to mark compliance done ?')
                      "
                      @click="markComplicanceDone"
                    >
                      <v-icon>mdi-check</v-icon>
                      {{ $i18n.t("Compliance Done") }}
                    </z-confirm-button>
                    <v-btn
                      color="info"
                      class="mr-0"
                      @click="save()"
                      :loading="loading"
                      :disabled="!isValid"
                    >
                      <h3>{{ $i18n.t("Save") }}</h3>
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-card>
                    <v-tabs
                      v-model="activeTab"
                      vertical
                      background-color="white"
                      light
                      color="primary"
                    >
                      <v-tab key="home" class="float-left justify-start">
                        <v-icon class="me-5">mdi-account-alert</v-icon>
                        {{ $i18n.t("Profile") }}
                      </v-tab>

                      <v-tab key="addresss" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-map-marker</v-icon>
                        {{ $i18n.t("Address") }}
                      </v-tab>

                      <v-tab key="photos" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-image-multiple</v-icon>
                        {{ $i18n.t("Pictures") }}
                      </v-tab>

                      <v-tab key="others" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-account-details</v-icon>
                        {{ $i18n.t("Details") }}
                      </v-tab>

                      <v-tab
                        key="policeVerify"
                        v-if="isEdit"
                        class="justify-start"
                      >
                        <v-icon class="me-5">mdi-police-badge-outline</v-icon>
                        {{ $i18n.t("Police Verification") }}
                      </v-tab>

                      <v-tab key="expenses" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-cash-multiple</v-icon>
                        {{ $i18n.t("Cash/Salary/Expenses") }}
                      </v-tab>

                      <v-tab
                        key="insurance"
                        v-if="isEdit"
                        class="justify-start"
                      >
                        <v-icon class="me-5">mdi-shield-account</v-icon>
                        {{ $i18n.t("Insurance") }}
                      </v-tab>

                      <v-tab key="permits" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-book-open-outline</v-icon>
                        {{ $i18n.t("Driver Permits") }}
                      </v-tab>

                      <v-tab key="config" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-cog</v-icon>
                        {{ $i18n.t("Configuration") }}
                      </v-tab>
                    </v-tabs>
                  </v-card>
                </v-col>
              </v-row>
              <v-row></v-row>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { VueEditor } from "vue2-editor";
import Expenses from "@/views/driver/Expenses.vue";
import Addresss from "@/views/driver/Addresss.vue";
import CashSalary from "@/views/driver/CashSalary.vue";
import Config from "@/views/driver/Config.vue";
import Insurance from "@/views/driver/Insurance.vue";
import Other from "@/views/driver/Other.vue";
import Permits from "@/views/driver/Permits.vue";
import Pictures from "@/views/driver/Pictures.vue";
import PoliceVerify from "@/views/driver/PoliceVerify.vue";
import Profile from "@/views/driver/Profile.vue";
import auth from "@/store/user/module/auth";

@Component({
  name: "DriverEdit",
  components: {
    VueEditor,
    Expenses,
    Addresss,
    CashSalary,
    Config,
    Insurance,
    Other,
    Permits,
    Pictures,
    PoliceVerify,
    Profile,
  },
  props: {
    driver_id: {
      default: null,
    },
    singlePage: {
      default: false,
    },
  },
})
export default class DriverEdit extends Vue {
  isValid = true;
  isEdit = false;
  activeTab = "home";
  ePage = 1;
  eRows = 30;
  driverExpense = {};
  driverPOSO = {
    _id: null,
    driverDetail: { name: "" },
    type: 0,
    countryCode: null,
    phone: null,
  };
  driver = this.driverPOSO;
  migrate = {};
  id = null;

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 75 : 240;
  }

  addItem(_list) {
    if (!_list) {
      _list = [];
    }
    _list.push({});
    return _list;
  }

  remove(list, index) {
    if (list && index != null && index != undefined) {
      list.splice(index, 1);
    }
  }

  get loading() {
    return common.loading;
  }

  createNew() {
    this.$router.push("/driver/create");
  }

  preSaveValidation() {
    if (!this.driver) {
      common.setError("Driver Empty");
      return false;
    }

    return true;
  }

  async save() {
    try {
      if (!this.preSaveValidation()) {
        return;
      }

      let url_post;
      if (this.isEdit) {
        url_post = "/api/driver/update/" + this.id;
      } else {
        url_post = "/api/driver/new";
      }

      common.setLoading(true);
      const driver = await doPost(url_post, this.driver);
      common.setLoading(false);
      common.showMessage(`Driver ${driver.name} Saved Successfully`);

      if (this.singlePage) {
        this.$emit("select", {
          name: driver.name,
          _id: driver._id,
        });
        this.driver = this.driverPOSO;
      } else if (!this.id) {
        this.$router.push("/driver/" + driver._id);
        await this.get(driver.id);
      } else {
        await this.get(driver.id);
      }
      this.id = driver._id;
      this.isEdit = true;
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  postFetchDriver(_driver) {
    if (!_driver.blockedFor) _driver.blockedFor = [];
    if (!_driver.driverDetail) _driver.driverDetail = {};
    if (!_driver.driverDetail.address) _driver.driverDetail.address = {};
    if (!_driver.driverDetail.permanentAddress)
      _driver.driverDetail.permanentAddress = {};
    if (!_driver.driverDetail.insurance) _driver.driverDetail.insurance = {};
    if (!_driver.driverDetail.pictures) _driver.driverDetail.pictures = {};
    if (!_driver.driverDetail.policeVerifyPic)
      _driver.driverDetail.policeVerifyPic = {};
  }

  async get(id) {
    try {
      const driver = await doGet("/api/driver/" + id + "/driverDetail");
      if (this.isSet(driver._id)) {
        this.isEdit = true;
        this.id = driver._id;

        this.postFetchDriver(driver);

        if (driver) this.driver = driver;
      }
    } catch (e) {
      common.setError(e.message);
    }
  }

  async markComplicanceDone() {
    common.setLoading(true);
    if (this.driver._id) {
      try {
        await doGet("/api/driver/" + this.driver._id + "/compliant/done");
        common.showMessage("Updated Successfully");
        await this.get(this.driver._id);
      } catch (e) {
        common.setError(e.message);
      }
    }
    common.setLoading(false);
  }

  isPDF(_url) {
    if (_url && _url.includes(".pdf")) {
      return true;
    }
    return false;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async mounted() {
    if (this.singlePage) {
      if (this.driver_id) {
        await this.get(this.driver_id);
      }
    } else if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    } else {
      if (auth.authContent) {
        this.driver.countryCode = !isNaN(auth.authContent.countryCode)
          ? parseInt(auth.authContent.countryCode)
          : null;
      }
    }
  }
}
</script>
<style scoped>
.driver-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.image-download {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: #42a5f5;
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>
